<template>
  <div>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="notification_box class_question">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div
              class="padding_rl20 heading"
              v-if="ivdrTotalComponents == ivdrCurrCtr"
            >
              Performing classification for kit '{{
                prodClassCriteria.device_name
              }}'. All the components are classified in Kit.Please
              finalize results to get final classification.
            </div>
            <div class="padding_rl20" v-else>
              Performing classification for kit
              '{{ prodClassCriteria.device_name }}'. Once all the components
              are classified Kit's class will be derived.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="row"
      v-if="
        prodClassCriteria.workflowResponseMap &&
        !(prodClassCriteria.workflowResponseMap.size === 0)
      "
    >
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <base-collapse
          class="prod-class"
          v-model="activeNames"
          @change="handleChange"
        >
          <div
            class="comp_name"
            v-for="(
              cache, keyMod
            ) in prodClassCriteria.workflowResponseMap"
            v-bind:key="keyMod"
          >
            <base-collapse-item
              class="padding_rl20"
              :title="
                'Component \'' +
                cache[1].name +
                '\' of medical kit \'' +
                prodClassCriteria.device_name +
                '\' is classified  \'' +
                cache[1].classCode+'\''"
              :name="cache[1].name"
            >
              <div class="row">
                <div
                  class="notification_box question_details"
                  v-if="prodClassCriteria.current_slide_number === 2"
                >
                  <div
                    class="row padding_rl20 class_question"
                    v-if="debug === true"
                  >
                    <div class="col-md-5 col-xs-5">Classification Question</div>
                    <div class="col-md-3 col-xs-3">Response</div>
                    <div class="col-md-1 col-xs-1">Level</div>
                    <div class="col-md-2 col-xs-2">Interim Class/Class</div>
                    <div class="col-md-1 col-xs-1">Rule Ref</div>
                  </div>
                  <div class="row padding_rl20 class_question" v-else>
                    <div class="col-md-8 col-xs-8">Classification Question</div>
                    <div class="col-md-4 col-xs-4">Response</div>
                  </div>
                  <div class="hr-thin-summary"></div>
                  <div
                    v-for="(data, newIndex) in workflowDataArray(
                      cache[1].cache
                    )"
                    v-bind:key="newIndex + '_X'"
                    class="row padding_rl20"
                    style="padding-bottom: 5px"
                  >
                    <div class="class_question_summary" v-if="debug == true">
                      <div class="col-md-5 col-xs-5 class_question_summary">
                        <span v-if="keyMod < prodClassCriteria.workflowResponseMap.size-1" v-html="data.question"></span>
                        <a v-else
                          href="javascript:void(0);"
                          class="service"
                          @click="navigateBack(data.step,keyMod)"
                        >
                          <span v-html="data.question"></span>
                        </a>
                        <i class="fas fa-redo"></i>
                        <base-tooltip
                          :content="`Click to jump to Step -> ${data.step}`"
                          v-if="info == true"
                        >
                          <!-- <div
                            class="tooltip_content tooltip-width"
                            slot="content"
                          >
                            <span style="overflow-wrap: normal"
                              >Click to jump to Step -> {{ data.step }}</span
                            >
                          </div> -->
                          <span class="email_tooltip">
                            <i class="fa fa-question-circle"></i>
                          </span>
                        </base-tooltip>
                      </div>
                      <div class="col-md-3 col-xs-3">
                        <span v-if="data.answer" v-html="data.answer" />
                        <span v-else v-html="cache[1].name" />
                      </div>
                      <div class="col-md-1 col-xs-1">{{ data.level }}</div>
                      <div class="col-md-2 col-xs-2">
                        <span v-html="data.interimClass"></span>
                        <span v-if="!data.classCode"
                          >/<span v-html="data.classCode"></span
                        ></span>
                      </div>
                      <div class="col-md-1 col-xs-1">{{ data.ruleRef }}</div>
                    </div>
                    <div class="class_question_summary" v-else>
                      <div v-if="keyMod < prodClassCriteria.workflowResponseMap.size-1" class="col-md-8 col-xs-8">
                        <span  v-html="data.question"></span>
                      </div>
                      <div v-else class="col-md-8 col-xs-8">
                        <a
                          href="javascript:void(0);"
                          class="service"
                          @click="navigateBack(data.step,keyMod)"
                        >
                          <span v-html="data.question"></span>
                        </a>
                        <base-tooltip
                          :content="`Click to Go Back to Step -> ${ data.step }`"
                          v-if="info == true"
                        >
                          <!-- <div
                            class="tooltip_content tooltip-width"
                            slot="content"
                          >
                            <span style="overflow-wrap: normal"
                              >Click to Go Back to Step -> {{ data.step }}</span
                            >
                          </div> -->
                          <span class="email_tooltip">
                            <i class="fa fa-question-circle"></i>
                            <i class="fa fa-undo" aria-hidden="true"></i>
                          </span>
                        </base-tooltip>
                      </div>
                      <div class="col-md-4 col-xs-4">
                        <span v-if="data.answer" v-html="data.answer"/>
                        <span v-else v-html="cache[1].name"/>
                      </div>
                    </div>
                    <div class="row padding_rl20 hr-thin-separator"></div>
                  </div>
                </div>
              </div>
            </base-collapse-item>
          </div>
        </base-collapse>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCollapse from '../Common/BaseCollapse.vue';
import BaseCollapseItem from '../Common/BaseCollapseItem.vue';
import BaseTooltip from '../Common/BaseTooltip.vue';

export default {
  props: [
    'prodClassCriteria',
    'debug',
    'info',
    'compositeArrayWrapper',
    'ivdrCurrCtr',
    'ivdrTotalComponents',
    'pageConfig',
  ],
  components: { BaseTooltip, BaseCollapse, BaseCollapseItem },
  data() {
    return {
      activeNames: this.prodClassCriteria.componentName,
    };
  },
  computed: {
    classData() {
      const classData = {
        code: this.prodClassCriteria.compositeArrayWrapper.classCode,
        flag: this.prodClassCriteria.compositeArrayWrapper.classFoundFlag,
      };
      return classData;
    },
    sortedLevelArray() {
      const sortedLevelAray = this.prodClassCriteria.levelArray;
      return sortedLevelAray;
    },
    arrayLengths() {
      const arrLengthHolder = {
        srch_cri_arr_len: this.prodClassCriteria.searchCriteriaArray
          ? this.prodClassCriteria.searchCriteriaArray.length
          : null,
        wf_resp_arr: this.prodClassCriteria.workflowResponseCache
          ? this.prodClassCriteria.workflowResponseCache.length
          : null,
      };
      return arrLengthHolder;
    },
  },
  methods: {
    navigateBack(stepToJumpTo, mapIndex) {
      const headerCompCached = this.prodClassCriteria.workflowResponseMap.get(mapIndex);
      headerCompCached.classCode = null;
      headerCompCached.classNotes = null;
      this.prodClassCriteria.workflowResponseCache = [...headerCompCached.cache];
      const noOfElementsToPop = this.prodClassCriteria.workflowResponseCache.length - stepToJumpTo;
      for (let idx = 1; idx <= noOfElementsToPop; idx += 1) {
        this.prodClassCriteria.workflowResponseCache.pop();
        this.prodClassCriteria.levelArray.pop();
        // Delete elements from the back in the map that is keeping selected Queries.
        const keys = [...this.$parent.searchCriteriaMap.keys()];
        const lastKey = keys[keys.length - 1];
        this.$parent.searchCriteriaMap.delete(lastKey);
        this.$parent.levelArrayMap.delete(lastKey);
        this.prodClassCriteria.interimClassMap.delete(lastKey);
      }

      this.prodClassCriteria.compositeArrayWrapper.dataArray = [
        this.prodClassCriteria.workflowResponseCache[
          this.prodClassCriteria.workflowResponseCache.length - 1
        ].response_data,
      ];
      const choicesObj = this.prodClassCriteria.workflowResponseCache[
        this.prodClassCriteria.workflowResponseCache.length - 1
      ].choices;
      this.prodClassCriteria.selectedOptions = choicesObj;
      this.prodClassCriteria.current_slide_number = 1;
      this.$parent.resetClassInfo();
      this.$parent.ivdrCurrCtr -= 1;
    },
    handleChange() {},
    workflowDataArray(wfResponseCache) {
      const workflowDataArray = [];
      let indx = 0;
      // const wfResponseCache = this.prodClassCriteria.workflowResponseCache;
      if (wfResponseCache && wfResponseCache.length > 0) {
        wfResponseCache.forEach((srchCritArrElement) => {
          if (srchCritArrElement) {
            const currTitleDataAndChildOptions = srchCritArrElement.response_data;
            const { choices } = srchCritArrElement;
            let answer = '';
            let levelComputed = '';
            let ruleRef = '';
            let intClass = '';
            const valArray = choices.split('|');
            [answer] = valArray;
            levelComputed += valArray[2];
            [, , , , , , ruleRef] = valArray;
            [, , , , , intClass] = valArray;

            const workflowDataIns = {
              step: (indx += 1),
              question: currTitleDataAndChildOptions.vital_characteristic,
              answer,
              level: levelComputed,
              interimClass: intClass,
              ruleRef,
            };
            workflowDataArray.push(workflowDataIns);
          }
        });
      }
      return workflowDataArray;
    },
  },
  mounted() {},
};
</script>
<style scoped>
.notification_box {
  min-height: 110px;
  position: relative;
  display: block;
  background: #ffffff;
  box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  margin-left: 20px;
  margin: 15px 20px 10px 20px;
  padding: 14px 10px 10px 2px;
}
.question_details {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.7);
}
.class_question {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 23px;
  display: flex;
  align-items: center;
  color: #00518a;
}
.padding_rl20 {
  padding-right: 20px;
  padding-left: 20px;
}
.class_question_summary {
  font-size: 15px;
  line-height: 23px;
}
.prod-class .el-collapse {
  border-top: 1px solid #ebeef5;
  border-bottom: 0px solid transparent #ebeef5;
  padding-right: 20px;
  border-radius: 0px;
  margin-top: 5px;
  margin-bottom: 5px;
}
.prod-class .el-collapse-item__header {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
  display: flex;
  align-items: center;
  letter-spacing: 0em;
  text-align: left;
  min-height: 70px;
  color: #00518a;
  line-height: 25px;
}
</style>
